import { useGlobalAdmin } from '@/hooks/useGlobalAdmin';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Globe, Building } from 'lucide-react';

export function SiteSwitcher() {
  const { isGlobalAdmin, sites, selectedSiteId, setSelectedSiteId, selectedSite } = useGlobalAdmin();

  if (!isGlobalAdmin || sites.length <= 1) {
    // Show current site info for non-global admins
    if (selectedSite) {
      return (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Building className="h-4 w-4" />
          <span>{selectedSite.name}</span>
        </div>
      );
    }
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <Globe className="h-4 w-4 text-primary" />
      <Select value={selectedSiteId || ''} onValueChange={setSelectedSiteId}>
        <SelectTrigger className="w-[250px] h-9">
          <SelectValue placeholder="Select a site" />
        </SelectTrigger>
        <SelectContent>
          {sites.map((site) => (
            <SelectItem key={site.id} value={site.id}>
              <div className="flex flex-col">
                <span className="font-medium">{site.name}</span>
                <span className="text-xs text-muted-foreground">
                  {site.primary_domain || site.location_served}
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
